export const setLang = (lang = 'es') => ({
  type: 'SET_LANG',
  lang
})

export const setAccessToken = (tokenData = {}) => ({
  type: 'SET_TOKEN_DATA',
  tokenData
})